<input
  #stringInput
  type="text"
  blazeInputMask
  predefinedMask="numberInputMask"
  [maskOptions]="maskOptions"
  [formControl]="percentFormControl"
  [ngStyle]="config?.inputStyles"
  class="string-input"
/>
